<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Configuration</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Configuration</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="configuration">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <div class="card-tools">

              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">

                  <div class="form-group required">
                    <label class="control-label">Max Balance</label>
                    <div class="input-group">
                      <input type="text" id="max_balance" name="max_balance"
                             v-bind:class="{'has-error' : errors.has('max_balance')}"
                             v-validate="'required'"
                             v-model="value.value" class="form-control max_balance"
                             placeholder="Max Balance">
                      <div class="input-group-prepend">
                        <button type="button" class="btn btn-info btn-sm m-2px" @click="showConfigLogs()" >
                          <i class="fas fa-history"></i>
                        </button>
                      </div>
                    </div>

                    <div class="help text-danger" v-show="errors.has('max_balance')">
                      {{ errors.first("max_balance") }}
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
    <b-modal title="Global Configuration Logs" id="configLogs" hide-footer size="lg">
      <div class="table-responsive">
        <table class="table table-striped table-border">
          <thead class="bg-info">
          <tr>
            <th>SL</th>
            <th>Previous Data</th>
            <th>Current Data</th>
            <th>Changed By</th>
            <th>Date</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(log,i) in configLogs">
            <td>{{i+1}}</td>
            <td><pre>{{JSON.parse(log.previous_data)}}</pre></td>
            <td><pre>{{JSON.parse(log.current_data)}}</pre></td>
            <td>{{log.user}}</td>
            <td>{{customFormatter(log.date, 'lll')}}</td>
          </tr>
          </tbody>
        </table>
        <div class="clearfix"></div>
      </div>
    </b-modal>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from '@/services/api'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import axios from 'axios'
import moment from "moment";

export default {
  name: 'ConfigurationForm',
  metaInfo: {
    title: 'Config | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    value: {},
    pre: {},
    configLogs: [],
  }),
  methods: {
    customFormatter(date, format = 'MMM Do YY, h:mm:ss a') {
      return moment(date).format(format);
    },
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true
          let api_url = '/update-configuration'
          axios({
            method: 'PUT',
            url: api_url,
            data: {
              value: _this.value.value
            },
            headers: {'Content-Type': 'application/json'},
          }).then(function (response) {
            _this.$toaster.success(response.data.message)
            _this.is_loading = false
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message)
            }
            _this.$setErrorsFromResponse(errors.response.data)
          }).finally(() => {
            _this.is_loading = false
          });
        }
      });
    },
    getConfiguration: function () {
      return new Promise((resolve, reject) => {
        let api_url = '/get-configuration'
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error)
          });
      });
    },
    async initialize() {
      this.is_loading = true
      await this.getConfiguration().then(response => {
        this.value = response.data

      }).catch((error) => {
        console.log(error.response)
      })

      this.is_loading = false
    },
    showConfigLogs: function () {
      this.getConfigLogs(this.value.id).then(response => {
        this.configLogs = response.data
        this.$bvModal.show('configLogs')
      });
    },
    getConfigLogs: function (id) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line camelcase
        const api_url = '/get-configuration-logs/' + id;
        axios.get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch((error) => {
            console.error('error ' + error)
            reject(error)
          })
          .finally(() => {
          });
      })
    },
  },
  mounted() {
    this.initialize()

  },

}
</script>

